module.exports = __webpack_public_path__ + "img/DK32301908.f45862a4.png";